// import React from 'react';
// import { Icon } from '@iconify/react';
// import { Link } from 'react-router-dom';

// export default function Button({ btnLink, btnText, variant, icon }) {
//   return (
//     <Link
//       to={btnLink}
//       className={variant ? `cs-text_btn ${variant}` : 'cs-text_btn'}
//     >
//       <>
//         <span>{btnText}</span>
//         {icon ? icon : <Icon icon="bi:arrow-right" />}
//       </>
//     </Link>
//   );
// }


import React from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

export default function Button({ btnLink, btnText, variant, icon, onClick, type = 'button', className, disabled = false }) {
  const classNames = `${variant ? `cs-text_btn ${variant}` : 'cs-text_btn'} ${className}`;

  if (btnLink) {

    return (
      <Link to={btnLink} className={classNames}>
        <span>{btnText}</span>
        {icon || <Icon icon="bi:arrow-right" />}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} className={className} disabled={disabled}>
      <span>{btnText}</span>
      {icon || <Icon icon="bi:arrow-right" />}
    </button>
  );
}
